<template>
  <main>
    <LoaderPage v-if="isLoading" />
    <template v-else>
      <IOSInstallBanner />
      <!-- <NotificationHandler /> -->
      <!-- <NotificationBadge /> -->
      <router-view />
    </template>
  </main>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import LoaderPage from "./view/loader/LoaderPage.vue";
import IOSInstallBanner from "@/components/IOSInstallBanner.vue";
import {getMessaging, getToken, onMessage} from "firebase/messaging";

// import NotificationHandler from "@/components/notifications/NotificationHandler.vue";
// import NotificationBadge from "@/components/notifications/NotificationBadge.vue";

const isLoading = ref(true); // initially true

onMounted(() => {
  setTimeout(() => {
    isLoading.value = false;
  }, 1000); // matches your loader.js delay
});

const router = useRouter();

router.beforeEach((to, from, next) => {
  isLoading.value = true;
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    isLoading.value = false;
  }, 500); // or 1000 to match startup delay
});

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0HY-Ge8hxjIL09Lxpwx1rAeI3CHgnyUQ",
  authDomain: "axefood-delivery.firebaseapp.com",
  projectId: "axefood-delivery",
  storageBucket: "axefood-delivery.firebasestorage.app",
  messagingSenderId: "870779106373",
  appId: "1:870779106373:web:9a2ba8dea3abc8b4f95f2c",
  measurementId: "G-G8BTGXRXCR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log(app.name);

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
const messaging = getMessaging();
onMessage(messaging, (payload) => {
  console.log("Message received. ", payload);
  // ...
});
getToken(messaging, {
  vapidKey:
    "BPsFpCtyxykMZEpDJq2cMIf53kHt1nlEk_9Y3glFocjAMUoFlEiZZETGFz524AHa1gL2ytnKotNh4LZjtHA1Wy4",
})
  .then((currentToken) => {
    if (currentToken) {
      // Send the token to your server and update the UI if necessary
      // ...

      console.log("Token is:", currentToken);
    } else {
      // Show permission request UI
      console.log("No registration token available. Request permission to generate one.");
      // ...
    }
  })
  .catch((err) => {
    console.log("An error occurred while retrieving token. ", err);
    // ...
  });
</script>
